import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const CreateGenericAccountBasicDetailsFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};

  .MuiGrid2-root {
    padding-right: 8px;
    padding-left: 8px;
    ${responsive.MOBILE`
      padding-right: 0px;
      padding-left: 0px;
    `}
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .main-container {
    width: 100%;
    padding: 24px 8px 16px;
    ${responsive.TABLET_PORTRAIT`
      padding: 24px 8px;
    `}
    ${responsive.MOBILE`
      padding: 16px 8px;
    `}
  }

  .form-field {
    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    &:nth-child(n + 4) {
      margin-top: 40px;
    }
    &.inner {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
      }
    `}
  }
`;
